export default "__VITE_ASSET__CAJ1QEfs__"